import { questionTemplateService } from '../../services';
import { notificationActions } from './notification.actions';

export const questionTemplateConstants = {
  GETALL_REQUEST: 'QUESTION_TEMPLATES_GETALL_REQUEST',
  GETALL_SUCCESS: 'QUESTION_TEMPLATES_GETALL_SUCCESS',
  GETALL_FAILURE: 'QUESTION_TEMPLATES_GETALL_FAILURE',

  GET_BY_TYPE_REQUEST: 'QUESTION_TEMPLATE_GET_BY_TYPE_REQUEST',
  GET_BY_TYPE_SUCCESS: 'QUESTION_TEMPLATE_GET_BY_TYPE_SUCCESS',
  GET_BY_TYPE_FAILURE: 'QUESTION_TEMPLATE_GET_BY_TYPE_FAILURE',

  UPSERT_REQUEST: 'QUESTION_TEMPLATE_UPSERT_REQUEST',
  UPSERT_SUCCESS: 'QUESTION_TEMPLATE_UPSERT_SUCCESS',
  UPSERT_FAILURE: 'QUESTION_TEMPLATE_UPSERT_FAILURE',
};

const getAllTemplates = () => {
  return async (dispatch: any) => {
    dispatch({ type: questionTemplateConstants.GETALL_REQUEST });

    try {
      const response = await questionTemplateService.getAllTemplates();
      dispatch({ 
        type: questionTemplateConstants.GETALL_SUCCESS, 
        payload: response.data 
      });
    } catch (error: any) {
      dispatch({ 
        type: questionTemplateConstants.GETALL_FAILURE, 
        payload: error.toString() 
      });
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

const getTemplateByType = (questionTypeId: number) => {
  return async (dispatch: any) => {
    dispatch({ type: questionTemplateConstants.GET_BY_TYPE_REQUEST });

    try {
      const response = await questionTemplateService.getTemplateByType(questionTypeId);
      dispatch({ 
        type: questionTemplateConstants.GET_BY_TYPE_SUCCESS, 
        payload: { questionTypeId, template: response.data } 
      });
    } catch (error: any) {
      dispatch({ 
        type: questionTemplateConstants.GET_BY_TYPE_FAILURE, 
        payload: error.toString() 
      });
      // Không show error notification cho trường hợp không tìm thấy template
    }
  };
};

const upsertTemplate = (questionTypeId: number, templateJson: any) => {
  return async (dispatch: any) => {
    dispatch({ type: questionTemplateConstants.UPSERT_REQUEST });

    try {
      const response = await questionTemplateService.upsertTemplate(questionTypeId, templateJson);
      dispatch({ 
        type: questionTemplateConstants.UPSERT_SUCCESS, 
        payload: response.data 
      });
      dispatch(notificationActions.addNotification('Template saved successfully', 'SUCCESS'));
    } catch (error: any) {
      dispatch({ 
        type: questionTemplateConstants.UPSERT_FAILURE, 
        payload: error.toString() 
      });
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

export const questionTemplateActions = {
  getAllTemplates,
  getTemplateByType,
  upsertTemplate,
};
